import { Component } from '@angular/core'
import { CmsComponentData, LinkComponent } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { EbCmsLinkComponent } from '../../footer/interfaces/eb-cms.interfaces'

@Component({
    selector: 'cx-link',
    templateUrl: './eb-link.component.html',
    standalone: false
})
export class EbLinkComponent extends LinkComponent {
  constructor(protected component: CmsComponentData<EbCmsLinkComponent>) {
    super(component)
  }

  data$: Observable<EbCmsLinkComponent> = this.component.data$.pipe(
    tap(data => (this.styleClasses = data?.styleClasses))
  )
}
